import React, { useEffect, useRef, useState } from "react";
import icon from "./assets/aboutus/freightphilosphy.png";
import pointIcon from "./assets/aboutus/pinmarker.png";

const FreightPhilosophy = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Disconnect after first visibility trigger
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);


  return (
    <section
      ref={sectionRef}
      className=" text-white px-6 md:px-16 pt-20 pb-40 relative overflow-hidden"
    >
      <style>{`
        .fade-in { animation: fadeIn 0.6s ease-out forwards; }
        .slide-left { animation: slideLeft 0.7s ease-out forwards; }
        .slide-right { animation: slideRight 0.7s ease-out forwards; }
        .pop-in { animation: popIn 0.4s ease-out forwards; }
        .draw-path {
          stroke-dasharray: 8,8;
          stroke-dashoffset: 1000;
          animation: drawPath 1.2s ease-out forwards;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes slideRight {
          from { opacity: 0; transform: translateX(-80px); }
          to { opacity: 1; transform: translateX(0); }
        }

        @keyframes slideLeft {
          from { opacity: 0; transform: translateX(80px); }
          to { opacity: 1; transform: translateX(0); }
        }

        @keyframes popIn {
          0% { transform: scale(0); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes drawPath {
          to { stroke-dashoffset: 0; }
        }
      `}</style>

      {/* Top Section */}
      <div className={`max-w-4xl mx-auto text-center mb-20 ${isVisible ? "fade-in" : "opacity-0"}`}>
        <img src={icon} alt="Icon" className="mx-auto h-20 mb-6" />
        <h2 className="text-4xl md:text-5xl font-bold mb-6">Our Freight Philosophy</h2>
        <p className="text-lg md:text-xl leading-relaxed">
          At Big Blue, freight isn’t just about moving goods, it’s about moving businesses forward with clarity, care and control.
          We believe that global logistics should never feel overwhelming or uncertain. Whether it’s Air Blue cutting through the skies,
          Ocean Blue crossing continents or inland routes that connect local to global.
        </p>
      </div>

      {/* Route Section */}
<div className="relative max-w-6xl mx-auto h-auto lg:h-[450px] flex flex-col lg:block gap-12">
  {/* Left Box */}
  <div
    className={`bg-[#0D1B2A] text-white p-6 rounded-3xl max-w-sm z-10 shadow-lg mx-auto lg:mx-0 lg:absolute lg:top-0 lg:left-0 ${
      isVisible ? "slide-right" : "opacity-0"
    }`}
  >
    <p className="text-base leading-relaxed">
      Our job is to make logistics feel simple, strategic and human.
      That means proactive communication, precise timing and end-to-end support
      that feels like a true partnership. We don’t just deliver from
    </p>
  </div>

  {/* Point A (only on large screens) */}
  <div
    className={`absolute top-[120px] left-[420px] items-center gap-4 z-10 hidden xl:flex ${
      isVisible ? "pop-in" : "opacity-0"
    }`}
  >
    <span className="text-white font-bold text-4xl">Point A</span>
    <img src={pointIcon} alt="Point A" className="h-6" />
  </div>

  {/* Point B (only on large screens) */}
  <div
    className={`absolute bottom-[80px] left-[580px] items-center gap-2 z-10 hidden xl:flex ${
      isVisible ? "pop-in" : "opacity-0"
    }`}
  >
    <img src={pointIcon} alt="Point B" className="h-6" />
    <span className="text-white font-bold text-4xl">Point B</span>
  </div>

  {/* Right Box */}
  <div
    className={`bg-[#005DAB] text-white p-6 rounded-3xl max-w-sm z-10 shadow-lg mx-auto lg:mx-0 lg:absolute lg:bottom-0 lg:right-0 ${
      isVisible ? "slide-left" : "opacity-0"
    }`}
  >
    <p className="text-base leading-relaxed">
      We deliver peace of mind, real-time visibility and the freedom for our clients
      to focus on what they do best, growing their business.
    </p>
  </div>

  {/* SVG Path – visible only on large screens */}
  <svg
    className="absolute top-0 left-0 w-full h-full z-0 hidden lg:block"
    viewBox="0 0 1000 400"
    preserveAspectRatio="none"
  >
    <path
      d="M 500 120 Q 900 100 800 150 Q -150 330 500 308"
      stroke="#00B2FF"
      strokeWidth="2"
      fill="none"
      className={isVisible ? "draw-path" : ""}
    />
  </svg>
</div>

    </section>
  );
};

export default FreightPhilosophy;
